module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAOVBMVEUAAABnZ2dmZmZnZ2dmZmZnZ2dmZmZmZmZmZmZnZ2dtbW1oaGhmZmZnZ2dmZmZmZmZmZmZpaWlmZmZ7MAUPAAAAEnRSTlMA89eIbVMF3KUqC0Lhx8C1ji5+cAztAAAAlElEQVQoz51RWxLEIAgTKr76zv0Pu7bLujKd8aP5wSEkILjXCJKYiJMEm5cIRZQ+PwHscynZMzCZvP+9fccIMP+rZkC0b9T6polBBVzdqBpoYJWkS0Ag5zR4pJtgZKvIl8VdVZxBAfXEvp7nuivRrCo2VGzOqZU2rwjHshzhO29q4xowZPDB0UqeSxyufXwoe9q3+AD9vQe7Y4wmGgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emoji.png
// module id = 4EY9
// module chunks = 2